// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimProcessInvoiceItem from './claim-process-invoice/claim-process-invoice-item';
import {FormattedMessage} from 'react-intl';
import Invoice from '@deere/cps-it.warranty-model-factory/lib/invoice';
import MassProcessInvoiceItem from './mass-process-invoice/mass-process-invoice-item';
import User from '@deere/cps-it.warranty-model-factory/lib/user';

function handleButtonClick(invoice) {

    this.onDetailsButtonClick(invoice);

}

const DealerInvoiceList = props =>
    <div>
        {props.invoices.length || props.busyCounter ?
            <div className='dealer-invoice-list'>
                {props.invoices.map(invoice => {

                    const invoiceData = invoice.isMassProcessing ?
                        invoice.massProcess :
                        invoice.claimsProcess;

                    const InvoiceItem = invoice.isMassProcessing ?
                        MassProcessInvoiceItem :
                        ClaimProcessInvoiceItem;

                    return (
                        <div
                            className='invoice-list-item'
                            key={invoice.invoiceId}
                        >
                            <InvoiceItem
                                dealer={invoice.dealer}
                                invoice={invoiceData}
                                isInvoiceNumberVisible={true}
                                user={props.user}
                            />
                            {(!invoice.isMassProcessing || (invoice.isMassProcessing && invoice.massProcess.status.key === '1')) &&
                                <footer className='button-group'>
                                    <button
                                        className='primary'
                                        onClick={handleButtonClick.bind(props, invoice)}
                                    >
                                        <FormattedMessage id='VIEW_UPDATE'/>
                                    </button>
                                </footer>
                            }
                        </div>
                    );

                })}
            </div> :
            <FormattedMessage id='NO_DEALER_INVOICES'/>
        }
    </div>;

DealerInvoiceList.displayName = 'DealerInvoiceList';
DealerInvoiceList.propTypes = {
    busyCounter: PropTypes.number.isRequired,
    invoices: PropTypes.arrayOf(PropTypes.instanceOf(Invoice)).isRequired,
    onDetailsButtonClick: PropTypes.func.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default DealerInvoiceList;



// WEBPACK FOOTER //
// ./src/claim/dealer-invoices/components/dealer-invoice-list.js